import React, { lazy } from 'react';
import { CATEGORIES, MENU_PRODUCTS } from '../data/menuData';
import { useLanguage } from '../context/LanguageContext';
interface CategoryGridProps {
  onSelectCategory: (category: string) => void;
}
const CATEGORY_ICONS: Record<string, string> = {
  Sándwich: '🥪',
  Wrap: '🌯',
  Cremas: '🍲',
  'Snack Bowl': '🥣',
  Niños: '👶',
  Bebidas: '🥤'
};
export function CategoryGrid({
  onSelectCategory
}: CategoryGridProps) {
  const {
    t,
    translateCategory
  } = useLanguage();
  return <div className="mb-6" data-id="element-1024">
      <h2 className="text-xl font-heading font-bold text-white mb-4 px-1 tracking-wide" data-id="element-1025">
        {t('whatDoYouCrave')}
      </h2>
      <div className="grid grid-cols-2 gap-3" data-id="element-1026">
        {CATEGORIES.map(category => {
        const firstProduct = MENU_PRODUCTS.find(p => p.category === category);
        const emoji = CATEGORY_ICONS[category] || '🍽️';
        return <button key={category} onClick={() => onSelectCategory(category)} className="relative rounded-2xl overflow-hidden h-32 text-left group active:scale-[0.97] transition-transform border border-gray-800" data-id="element-1027">
              {firstProduct?.image ? <img src={firstProduct.image} alt={category} className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-1028" /> : <div className="absolute inset-0 bg-gray-800" data-id="element-1029" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" data-id="element-1030" />
              <div className="absolute bottom-0 left-0 right-0 p-3" data-id="element-1031">
                <span className="text-lg mb-0.5 block" data-id="element-1032">{emoji}</span>
                <h3 className="text-white font-heading font-bold text-base leading-tight" data-id="element-1033">
                  {translateCategory(category)}
                </h3>
              </div>
            </button>;
      })}
      </div>
    </div>;
}